import { AuthenticatedLayout } from './components'
import { AuthGate } from './auth/AuthGate'
import { AppRouter } from './router'

function App() {
  return (
    <AuthenticatedLayout>
      <AuthGate
        loadingMessage="Signing you in..."
        promptMessage="Sign in to access SFI Autopilot"
        buttonText="Sign In"
      >
        <AppRouter />
      </AuthGate>
    </AuthenticatedLayout>
  )
}

export default App
